<template>
    <div class="search-results-vehicle" :id="elementId">
        <template v-if="pictureCount == 0">
            <router-link :to="{ name: 'new-cars-in-stock-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a" class="search-results-vehicle__img-link" @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'Title')">
                <div class="search-results-vehicle__bg-img search-results-vehicle__bg-img--4-by-3" :style="{ 'background-image': 'url(' + backgroundImage + ')' }"></div>
                <picture>
                    <source media="(min-width: 992px)" :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                    <source srcset="/images/used/image-coming-soon.webp, /images/used/image-coming-soon@2x.webp 2x" type="image/webp" />
                    <img
                        class="search-results-vehicle__img"
                        srcset="/images/used/image-coming-soon.jpg, /images/used/image-coming-soon@2x.jpg 2x"
                        itemprop="thumbnail"
                        :alt="'Used ' + vehicle.vehicle_title + ' Photo Coming Soon'"
                    />
                </picture>
                <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                    <img src="/images/used/reserved-logo.png" srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x" alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                    <div class="vehicle__reserved-text">This car has now been <span class="vehicle__reserved-bold">reserved</span></div>
                </div>
            </router-link>
        </template>
        <template v-else>
            <router-link :to="{ name: 'new-cars-in-stock-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a" class="search-results-vehicle__img-link" @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'Title')">
                <div class="search-results-vehicle__bg-img search-results-vehicle__bg-img--4-by-3" :style="{ 'background-image': 'url(' + backgroundImage + ')' }"></div>
                <picture>
                    <source media="(min-width: 992px)" :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                    <img class="search-results-vehicle__img" :srcset="vehicle.used_vehicles_internal_images[0].thumbnail_path" alt="" />
                </picture>
                <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                    <img src="/images/used/reserved-logo.png" srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x" alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                    <div class="vehicle__reserved-text">This car has now been <span class="vehicle__reserved-bold">reserved</span></div>
                </div>
            </router-link>
        </template>

        <div class="search-results-vehicle__spacer"></div>
        <div class="search-results-vehicle__title-row">
            <router-link :to="{ name: 'new-cars-in-stock-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a" class="search-results-vehicle__title-area" @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'Title')">
                <h4 class="search-results-vehicle__title">{{ vehicle.manufacturer }} {{ vehicle.model }}</h4>
                <h5 class="search-results-vehicle__subtitle">{{ vehicle.version }}</h5>
            </router-link>
            <div class="search-results-vehicle__save-vehicle">
                <input type="checkbox" value="" class="save-to-compare" :id="'compare-' + vehicle.id"
                    name="save-to-compare" v-model="inCompareList" />
                <label :for="'compare-' + vehicle.id" class="search-results-vehicle__save-vehicle-button">
                    <svg :class="{ 'search-results-vehicle__save-vehicle-icon': true, 'search-results-vehicle__save-vehicle-icon--active': inCompareList }"
                        width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z" />
                    </svg>
                </label>
            </div>
        </div>
        <div class="search-results-vehicle__card-inner">
            <hr class="search-results-vehicle__hr" />

            <div class="search-results-vehicle__prices-container">
                <div class="search-results-vehicle__prices">
                    <router-link
                        :to="{ name: 'new-cars-in-stock-details', params: { id: vehicle.id, slug: vehicle.slug } }"
                        tag="a"
                        class="search-results-vehicle__price"
                        @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'Cash Price')"
                    >
                        Cash Price
                        <span class="search-results-vehicle__price-label">&pound;{{ vehicle.price_formatted }}</span>
                        <span class="pricing-area__vat-price" v-if="vehicle.vat_type == 'vat'">+VAT</span>
                    </router-link>
                    <div class="search-results-vehicle__price" v-if="finance == 'loading'">
                        Per Month
                        <span class="search-results-vehicle__per-month-error">
                            <div class="loading"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Results" /></div>
                        </span>
                    </div>
                    <div class="search-results-vehicle__price" v-else-if="finance == 'out-of-range' || !finance">
                        Per Month
                        <span class="search-results-vehicle__per-month-error">
                            Ask about finance
                        </span>
                    </div>
                    <router-link v-else :to="financeLink" tag="a" class="search-results-vehicle__price" @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'Finance')">
                        Per Month
                        <span class="search-results-vehicle__per-month-label">&pound;{{ monthlyPayment }}</span>
                    </router-link>
                </div>
                <auto-trader-value-rating class="search-results-vehicle__at-rating-container" :rating="vehicle.value_rating" :classes="{ 'at-lg-value-img': true, 'hidden-xs': true }"></auto-trader-value-rating>
            </div>

            <hr class="search-results-vehicle__hr" />

            <div class="search-results-vehicle__spec">{{ keySpec }}</div>

            <div class="search-results-vehicle__dealer" v-if="vehicle.l_name">
                <img src="/images/used/used-pin.svg" alt="Map pin" class="search-results-vehicle__pin" />
                {{ vehicle.l_name }}
            </div>

            <router-link :to="{ name: 'new-cars-in-stock-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a" class="btn btn--primary-inverted btn--full-width" @click.stop.native="gaTag('Stock Search Results', 'Card Clicked', 'View Details Button')">
                View Details
            </router-link>
        </div>
    </div>
</template>

<script>
import FinanceProducts from "../../api/finance/FinanceProducts";
import numberFormat from "../../api/NumberFormat";
import { financeKeys } from "../../../modules/json/financeKeys";
import AutoTraderValueRating from "../../components/AutoTraderValueRating";

export default {
    components: {
        AutoTraderValueRating,
    },
    props: {
        vehicle: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            financeProducts: new FinanceProducts(),
        };
    },
    watch: {
        "vehicle.finance": function (newVal, oldVal) {
            // watch it
            this.init();
        },
    },
    methods: {
        init() {
            if (this.vehicle.finance && this.vehicle.finance.FinanceProductResults) {
                this.financeProducts.setVehicle(this.vehicle);
                this.financeProducts.setProducts(this.vehicle.finance.FinanceProductResults);
            }
        },
        showRepresentativeExample() {
            this.$store.commit("RepresentativeExample/setPaymentSearch", this.stockSearchPaymentSearch);
            this.$store.commit("RepresentativeExample/setQuote", this.finance);
            this.$store.commit("RepresentativeExample/setVehicle", this.vehicle);
            this.$store.commit("RepresentativeExample/setShowModal", true);
        },
    },
    computed: {
        backgroundImage() {
            if (this.pictureCount > 0) {
                return this.vehicle.used_vehicles_internal_images[0].thumbnail_path;
            }

            return "/images/used/image-coming-soon@2x.jpg";
        },

        pictureCount() {
            if (this.vehicle.used_vehicles_internal_images) {
                return this.vehicle.used_vehicles_internal_images.length;
            }
            return 0;
        },

        inCompareList: {
            get() {
                return this.$store.state.Layout.compare.used.indexOf(String(this.vehicle.id)) == -1 ? false : true;
            },
            set(value) {
                this.$store.dispatch("Layout/saveVehicle", {
                    type: "used",
                    id: this.vehicle.id,
                    add: !this.inCompareList,
                });
            },
        },
        stockSearchPaymentSearch() {
            return this.$store.state.UsedSearchOptions.userOptions.stockSearchPaymentSearch;
        },
        elementId() {
            return "vehicle-result-" + this.vehicle.id;
        },
        mpg() {
            return numberFormat(this.vehicle.vehicle_mpg, 2);
        },
        vehicleType() {
            return this.vehicle.vehicle_type == "commercial" ? "Van" : "Car";
        },
        finance() {
            if (!this.vehicle.finance || this.vehicle.finance == "loading") {
                return "loading";
            }

            const manufacturerPcp = this.financeProducts.getQuoteOfKey(financeKeys['OVERAGE_PCP_ONLY']);
            if (manufacturerPcp) {
                return manufacturerPcp;
            }

            const hp = this.financeProducts.getQuoteOfKey(financeKeys.HP);
            if (hp) {
                return hp;
            }
            return false;
        },
        financeLink() {
            if (!this.finance || this.finance == "loading") {
                return { name: 'new-cars-in-stock-details', params: { id: this.vehicle.id, slug: this.vehicle.slug } }
            }
            const deposit = this.stockSearchPaymentSearch == 1 ? this.finance.Quote.Deposit.Cash : this.finance.Quote.CashDeposit;
            const term = this.finance.Quote.Term;
            const mileage = this.finance.Quote.AnnualMileage;
            const key = this.finance.Key;

            return {
                name: "new-cars-in-stock-details",
                params: { id: this.vehicle.id, slug: this.vehicle.slug },
                query: {
                    deposit: deposit,
                    term: term,
                    mileage: mileage,
                    key: key,
                },
            };
        },
        monthlyPayment() {
            if (!this.finance || this.finance == "loading") {
                return "";
            }
            if (this.stockSearchPaymentSearch == 1) {
                return numberFormat(this.finance.Quote.TotalRegularPayment, 0);
            }
            return numberFormat(this.finance.Quote.AllInclusiveRegularPayment, 0);
        },
        terms() {
            if (!this.finance || this.finance == "loading") {
                return "";
            }
            if (typeof this.finance.Product == "undefined" || typeof this.finance.Product.Lender == "undefined") {
                return "";
            }
            if (this.finance.Product.Lender == "PSA Finance") {
                return "Stellantis Financial Services UK Limited";
            }
            if (this.finance.Product.Lender == "Peugeot Financial Services") {
                return "Stellantis Financial Services UK Limited";
            }
            if (this.finance.Product.Lender == "Citroen Financial Services") {
                return "Stellantis Financial Services UK Limited";
            }
            if (this.finance.Product.Lender == "Black Horse") {
                return "Black Horse";
            }
            if (this.finance.Product.Lender == "DSG Finance Services") {
                return "DSG Finance Services";
            }
            if (this.finance.Product.Lender == "Vauxhall Finance") {
                return "Vauxhall Finance";
            }
            return "";
        },
        preReg() {
            return this.vehicle.pre_reg == 1 ? true : false;
        },
        nearlyNew() {
            return this.vehicle.nearly_new == 1 ? true : false;
        },
        priceWas() {
            return parseFloat(this.vehicle.price_was);
        },
        priceWasFormatted() {
            return numberFormat(this.priceWas, 0);
        },
        priceSave() {
            return parseFloat(this.vehicle.price_save);
        },
        priceSaveFormatted() {
            return numberFormat(this.priceSave, 0);
        },
        keySpec() {
            const keySpec = [];
            keySpec.push(this.shortTransmission);
            if (this.vehicle.no_doors) {
                keySpec.push(this.vehicle.no_doors + ' doors');
            }
            if (this.vehicle.body) {
                keySpec.push(this.vehicle.body);
            }
            if (this.vehicle.vehicle_reg_letter) {
                keySpec.push(this.vehicle.vehicle_reg_letter + ' Plate');
            }
            if (this.vehicle.fuel_type != '') {
                keySpec.push(this.vehicle.fuel_type);
            }
            if (this.mpg > 0) {
                keySpec.push(this.mpg + 'mpg');
            }
            return keySpec.join(' | ');
        },
        shortTransmission() {
            const transmission = String(this.vehicle.transmission).toLowerCase();
            if (transmission == 'automatic') {
                return 'Auto';
            }
            if (transmission == 'manual') {
                return 'Manual';
            }
            return this.vehicle.transmission;
        },
    },
    mounted() {
        this.init();
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/StockSearch/StockSearchVehicleResult.vue